import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { Carousel } from "@parkschannel/ui";
import classNames from "classnames";
import { ImgixImage } from "../../ImgixImage";
const responsive = {
    0: {
        items: 2
    },
    568: {
        items: 3
    },
    768: {
        items: 4
    },
    1280: {
        items: 6
    },
    1536: {
        items: 7
    },
    1800: {
        items: 8
    },
    1920: {
        items: 10
    }
};
export const OurPartnersCarousel = (param)=>{
    let { carouselRef , itemBackground , data  } = param;
    const slides = useMemo(()=>data.map((slide)=>/*#__PURE__*/ _jsx(OurPartnersCarouselItem, {
                data: slide,
                itemBackground: itemBackground
            }, slide.id)), [
        data
    ]);
    return /*#__PURE__*/ _jsx(Carousel, {
        disableDotsControls: true,
        responsive: responsive,
        paddingRight: 50,
        ref: carouselRef,
        items: slides
    });
};
function OurPartnersCarouselItem(param) {
    let { data , itemBackground ="white"  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("w-[120px] h-[120px] bg-white rounded-full flex items-center p-4 justify-center overflow-hidden lg:p-6 lg:w-[200px] lg:h-[200px] ", renderItemBackground(itemBackground)),
        children: /*#__PURE__*/ _jsx("a", {
            href: data.link,
            target: "_blank",
            className: "w-full h-full relative",
            children: /*#__PURE__*/ _jsx(ImgixImage, {
                src: data.avatar_key || "",
                fill: true,
                className: "object-contain",
                alt: "".concat(data.name, " logo")
            })
        })
    });
}
function renderItemBackground(bgc) {
    switch(bgc){
        case "gray":
            return "bg-neutral-50";
        default:
            return "bg-white";
    }
}
